import PropTypes from 'prop-types'
/* eslint max-len:0 */

import React, { Fragment, Component } from 'react'
import Link from 'base/react/components/link'
import LoginModal from 'desktop/components/modals/sneak_peek_login_modal'
import SiteLocation from 'base/constants/site_location'
import Banner from 'base/components/layout/banners/banner_from_config'
import { MOBILE_HEIGHT, DESKTOP_HEIGHT } from 'base/lib/banners'
import ReferralModal from 'mobile/containers/referrals/referral_modal'

class ReferralBanner extends Component {
  static propTypes = {
    nameOfReferrer: PropTypes.string.isRequired,
    platform: PropTypes.string,
  }

  state = {
    isShowingModal: false,
  }

  constructor(props) {
    super(props)

    this.handleShowModal = this.handleShowModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
  }

  getHeight() {
    return this.props.platform === 'mobile' ? MOBILE_HEIGHT : DESKTOP_HEIGHT
  }

  handleShowModal() {
    this.setState({ isShowingModal: true })
  }

  handleCloseModal() {
    this.setState({ isShowingModal: false })
  }

  renderMessaging() {
    const referrerMessage = this.props.nameOfReferrer
      ? `${this.props.nameOfReferrer} invited you to get a sneak peek!`
      : 'You’ve been invited to Everlane!'

    return (
      <Link inheritColor onClick={this.handleShowModal}>
        {referrerMessage}{' '}
        {this.props.platform !== 'mobile' && (
          <span>
            <span className="free-shipping-banner__link">Sign up</span> to get early access to our
            upcoming products.
          </span>
        )}
      </Link>
    )
  }

  renderReferralModal() {
    const { platform } = this.props

    if (platform === 'mobile') {
      return <ReferralModal onRequestClose={this.handleCloseModal} />
    } else {
      return (
        <LoginModal
          siteLocation={SiteLocation.REFERRAL_BANNER}
          onRequestClose={this.handleCloseModal}
        />
      )
    }
  }

  render() {
    return (
      <Fragment>
        {this.state.isShowingModal && this.renderReferralModal()}
        <Banner height={this.getHeight()}>{this.renderMessaging()}</Banner>
      </Fragment>
    )
  }
}

export default ReferralBanner
